import React, { useRef, useCallback } from 'react';
import { LinkButton } from '@adsk/alloy-react-button';
import PermissionSelect from '@adsk/alloy-react-permission-select';
import SelectBox from '@adsk/alloy-select-box';
import ProgressRing from '@adsk/alloy-react-progress-ring';
import { OverflowTooltip } from '@adsk/alloy-react-tooltip';
import ComputedPermissionsTooltip from '../ComputedPermissionsTooltip';
import {
  toolContainerStyle,
  getToolLinkStyle,
  permissionSelectContainerStyle,
  permissionSelectAuxContainerStyle,
  permissionSelectStyle,
  permissionSelectOverlayStyle,
  selectStyle,
  permissionsTextStyles,
  indicatorStyle,
} from './styles';

const ProductTools = ({ permissionsEditState, tools }) => {
  const toolContainerRef = useRef();

  const renderPermissions = useCallback(
    (tool, toolId) => {
      if (tool.permissions.loading) {
        return <ProgressRing style={{ marginLeft: '8px' }} />;
      }
      if (permissionsEditState) {
        if (tool.permissions.selectType === PermissionSelect.displayName) {
          return (
            <PermissionSelect
              container={toolContainerRef}
              data-testid={`ProductTool_PermissionSelect_${toolId}`}
              disabled={!permissionsEditState}
              overlayStyle={permissionSelectOverlayStyle}
              permissions={tool.permissions.selectOptions}
              showBorder
              showGroupLabel
              style={permissionSelectStyle}
              value={tool.permissions.selectValue}
            />
          );
        }

        return (
          <SelectBox
            container={toolContainerRef}
            data-testid={`ProductTool_SelectBox_${toolId}`}
            multiple={tool.permissions.multiple}
            options={tool.permissions.selectOptions}
            showValueAsTags={tool.permissions.multiple}
            style={selectStyle}
            value={tool.permissions.selectValue}
          />
        );
      }
      if (tool.permissions.selectType === PermissionSelect.displayName) {
        return (
          <PermissionSelect.Indicator
            data-testid={`ProductTool_PermissionSelect_Indicator_${toolId}`}
            label={
              <OverflowTooltip>
                {tool.permissions.selectValueLabel}
              </OverflowTooltip>
            }
            pillCount={4}
            pillValue={tool.permissions.pillValue}
            style={indicatorStyle}
          />
        );
      }

      return (
        <div
          css={permissionsTextStyles}
          data-testid={`ProductTool_PermissionValue_${toolId}`}
        >
          {tool.permissions.selectValueLabel}
        </div>
      );
    },
    [permissionsEditState]
  );

  return tools.map((tool) => {
    const toolId = tool.name.replace(/\s/g, '');

    return (
      <div
        key={tool.name}
        css={toolContainerStyle}
        ref={toolContainerRef}
        data-testid={`ProductTool_${toolId}`}
      >
        <LinkButton size={LinkButton.SIZES.SMALL}>
          <a
            css={getToolLinkStyle(!!tool.permissions)}
            data-testid={`ProductTool_LinkButton_${toolId}`}
            href={tool.url}
            rel="noreferrer"
            target="_blank"
          >
            {tool.name}
          </a>
        </LinkButton>
        {tool.permissions && (
          <div css={permissionSelectContainerStyle}>
            {tool.permissions.inheritedPermissions && (
              <ComputedPermissionsTooltip
                data-testid={`ProductTool_ComputedPermissionsTooltip_${toolId}`}
                inheritanceInfo={tool.permissions.inheritanceInfo}
                inheritedPermissionsInfo={
                  tool.permissions.inheritedPermissionsInfo
                }
                permissionsIndicatorProps={
                  tool.permissions.permissionsIndicatorProps
                }
                selectType={tool.permissions.selectType}
              />
            )}
            <div css={permissionSelectAuxContainerStyle}>
              {renderPermissions(tool, toolId)}
            </div>
          </div>
        )}
      </div>
    );
  });
};

export default ProductTools;
